<template>
  <div class="index-page" :class="{ loaded: pageLoaded }">

    <!-- SLIDER -->
    <div class="slider">

      <div
        class="slides"
        :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
      >
        <img
          v-for="(img, index) in images"
          :key="index"
          :src="img"
          alt="Raptoris services"
        />
      </div>

    </div>

    <!-- SERVICES -->
    <section class="services-section">
      <ServiceComponent />
    </section>

  </div>
</template>

<script>
import ServiceComponent from "./ServiceComponent.vue";

export default {
  name: "IndexComponent",

  components: { ServiceComponent },

  data() {
    return {
      currentIndex: 0,
      interval: null,
      pageLoaded: false,

      images: [
        "/images/img6.jpg",
        "/images/img5.jpg",
        "/images/img12 (2).jpg"
      ]
    };
  },

  mounted() {
    // SLIDER
    this.interval = setInterval(() => {
      this.nextSlide();
    }, 3000);

    // 🔥 ANIMACIÓN DE ENTRADA REAL
    setTimeout(() => {
      this.pageLoaded = true;
    }, 50);
  },

  beforeUnmount() {
    clearInterval(this.interval);
  },

  methods: {
    nextSlide() {
      this.currentIndex =
        (this.currentIndex + 1) % this.images.length;
    }
  }
};
</script>

<style scoped>

/* ===== PAGE ENTRY ===== */

.index-page {
  opacity: 0;
  transform: translateY(30px);
}

.index-page.loaded {
  animation: pageIn .8s ease forwards;
}

/* ===== SLIDER ===== */

.slider {
  width: 100%;
  height: 500px;
  overflow: hidden;
  border-radius: 20px;
  position: relative;
  box-shadow: 0 12px 30px rgba(0,0,0,.18);

  opacity: 0;
  transform: translateY(30px);
}

.loaded .slider {
  animation: fadeUp .8s ease forwards;
}

/* ===== SERVICES ===== */

.services-section {
  padding: 2rem 1rem;
  background: #f0f4f8;

  opacity: 0;
  transform: translateY(30px);
}

.loaded .services-section {
  animation: fadeUp .8s ease .25s forwards;
}

/* ===== SLIDES ===== */

.slides {
  display: flex;
  height: 100%;
  transition: transform 0.8s ease-in-out;
}

.slides img {
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* ===== ANIMATIONS ===== */

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pageIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== RESPONSIVE ===== */

@media (max-width: 1024px) {
  .slider {
    height: 380px;
    border-radius: 16px;
  }
}

@media (max-width: 768px) {
  .slider {
    height: 250px;
    border-radius: 12px;
  }

  .services-section {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .slider {
    height: 180px;
  }
}

</style>